import simpleParallax from "simple-parallax-js"

let MR = {
  drawSvgWhenInViewport: () => {
    let $svg = document.querySelectorAll(".draw-svg")

    let drawSvg = ($el) => {
      let rect = $el.getBoundingClientRect()

      if (rect.top >= 0 && rect.bottom - 100 <= (window.innerHeight || document.documentElement.clientHeight)) {
        if (!$el.classList.contains("is-drawn")) {
          $el.classList.add("is-drawn")
        }
      }
    }

    $svg.forEach((el) => drawSvg(el))
  },

  timer: (ms) => new Promise((res) => setTimeout(res, ms)),

  // helpHideToolTipRunner: async () => {
  //   // We need to wrap the loop into an async function for this to work
  //   for (let i = 0; i < 5; i++) {
  //     // MR.helpHideToolTip()
  //     await MR.timer(3000) // then the created Promise can be awaited
  //   }
  // },

  // helpHideToolTip: () => {
  //   if (typeof $zoho === "undefined") {
  //     return
  //   }
  //
  //   $zoho.salesiq.ready = () => {
  //     $zoho.salesiq.floatbutton.coin.hidetooltip()
  //   }
  //
  //   if (typeof $zoho !== "undefined" && $zoho?.salesiq?.floatbutton && window.innerWidth < 800) {
  //     $zoho.salesiq.ready = () => {
  //       $zoho.salesiq.floatbutton.coin.hidetooltip()
  //     }
  //   }
  // },

  enableZoomOnMapSide: () => {
    /*
     * inspired by https://css-tricks.com/how-to-detect-when-a-sticky-element-gets-pinned/
     */
    let $el = document.querySelector(".js-map-side-sticky")
    let observer = new IntersectionObserver(
      ([e]) => e.target.querySelector(".js-disabled-map-zoom").classList.toggle("is-free", e.intersectionRatio < 1),
      { threshold: [1] },
    )

    observer.observe($el)
  },

  initSimpleParallax: () => {
    let images = document.querySelectorAll(".js-simple-parallax")
    new simpleParallax(images, {
      orientation: "down",
      scale: 1.4,
    })
  },

  patchJqueryDatepickerPosition: () => {
    if (!window.jQuery?.datepicker || !window.jQuery.datepicker._findPos || window.jQuery.datepicker._riverFindPosPatched) {
      return
    }

    const originalFindPos = window.jQuery.datepicker._findPos

    window.jQuery.datepicker._findPos = function(obj) {
      if (!obj || !obj.offsetParent) {
        return [0, 0]
      }

      try {
        return originalFindPos.call(this, obj)
      } catch (error) {
        return [0, 0]
      }
    }
    window.jQuery.datepicker._riverFindPosPatched = true
  },

  addFooterBgWhenInViewport: () => {
    let $el = document.querySelector("footer")

    if (!$el) {
      return
    }

    let rect = $el.getBoundingClientRect()

    if (rect.top + 100 <= (window.innerHeight || document.documentElement.clientHeight)) {
      if (!$el.classList.contains("main-footer")) {
        $el.classList.add("main-footer")
      }
    }
  },
}

//MR.toggleMenu();
MR.drawSvgWhenInViewport()
//MR.toggleAnimatedHeader();

document.addEventListener("DOMContentLoaded", function(event) {
  // MR.helpHideToolTipRunner().then(() => {
  //   console.log("done")
  // })

  MR.initSimpleParallax()
  MR.patchJqueryDatepickerPosition()
})

window.addEventListener("load", function() {
  MR.patchJqueryDatepickerPosition()
})

document.addEventListener("scroll", function(e) {
  // if (document.querySelector(".map-side")) {
  //   MR.enableZoomOnMapSide()
  // }
  MR.drawSvgWhenInViewport()
  MR.addFooterBgWhenInViewport()
})
